"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Aitcraft45CircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Aitcraft45CircleLinear = function Aitcraft45CircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.042 15.96c-.592-.592-1.342-.954-2.158-.96-.819-.005-1.58.349-2.19.959l-5.574 5.574H17.933a1 1 0 00-.707.293l-2.933 2.933a1 1 0 00.51 1.688l12.836 2.567-3.52 3.519h-5.452a1 1 0 00-.707.293l-2.2 2.2a1 1 0 00.482 1.681l6.538 1.508 1.513 6.543a1 1 0 001.681.482l2.2-2.2a1 1 0 00.293-.707v-5.452l3.52-3.52 2.566 12.835a1 1 0 001.688.511l2.933-2.933a1 1 0 00.293-.707V25.88l5.574-5.574c.61-.61.964-1.371.959-2.19-.005-.816-.367-1.565-.958-2.157zm-2.934 1.413c.291-.292.559-.374.763-.373.207.001.473.09.756.373.283.283.372.549.373.756.001.204-.081.471-.373.763L37.76 24.76a1 1 0 00-.293.707v17.186l-1.319 1.32-2.567-12.835a1 1 0 00-1.688-.511L26.76 35.76a1 1 0 00-.293.707v5.453l-.632.632-1.247-5.395a1 1 0 00-.75-.75l-5.388-1.242.631-.631h5.453a1 1 0 00.707-.293l5.133-5.133a1 1 0 00-.51-1.688l-12.836-2.567 1.32-1.32h17.186a1 1 0 00.707-.292l5.867-5.867z",
    fill: "url(#Aitcraft45CircleLinear_svg__Aitcraft45CircleLinear_svg__paint0_linear_17373_95640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#Aitcraft45CircleLinear_svg__Aitcraft45CircleLinear_svg__paint1_linear_17373_95640)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aitcraft45CircleLinear_svg__Aitcraft45CircleLinear_svg__paint0_linear_17373_95640",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aitcraft45CircleLinear_svg__Aitcraft45CircleLinear_svg__paint1_linear_17373_95640",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.Aitcraft45CircleLinear = Aitcraft45CircleLinear;
var _default = Aitcraft45CircleLinear;
exports.default = _default;